var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Dropzone from "react-dropzone";
var DropzoneInput = function (props) {
    var files = props.files.length === 0 ? null : props.files;
    return (React.createElement("div", null,
        !files ? (React.createElement(Dropzone, { onDrop: function (filesToUpload, e) { return props.onChange(filesToUpload); }, accept: "video/*", multiple: false }, function (_a) {
            var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps;
            return React.createElement("div", __assign({}, getRootProps({ className: "dropzone z-depth-1" })),
                React.createElement("input", __assign({}, getInputProps())),
                React.createElement("p", { className: "center" }, "Try dropping a file here, or click to select a file to upload."),
                props.error && (React.createElement("span", { className: "error" }, props.error)));
        })) : null,
        files && Array.isArray(files) && (React.createElement("ul", null, files.map(function (file, i) { return (React.createElement("div", { key: i },
            React.createElement("button", { className: "btn btn-flat", onClick: function () { return props.reset(); } }, "Reset"),
            React.createElement("video", { key: i, className: "video-preview", controls: true },
                React.createElement("source", { key: file.name, src: file.preview })))); })))));
};
export default DropzoneInput;



//////////////////
// WEBPACK FOOTER
// ./src/components/videos/DropzoneInput.tsx
// module id = 571
// module chunks = 0